import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrderState } from '@b2b/features/order/core/store/order.reducer';

export const ORDER_FEATURE = 'ORDER';
export const selectOrder = createSelector(createFeatureSelector<OrderState>(ORDER_FEATURE), state => state);
